/* eslint-disable prettier/prettier */
/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/prop-types */
import CreateModal from 'components/custom/modal/CreateModal';
import InputBox from 'components/custom/forms/InputBox';
import { useFormik } from 'formik';
import useModalManage from 'hooks/custom/useModalManage';
import * as Yup from 'yup';
import { Col, Form, Row } from 'react-bootstrap';
import LabelInput from 'components/custom/forms/LabelInput';
import postData from 'services/postData';
import { useAlert } from 'providers/AlertModalProvider';
import apiEndpoints from 'constants/apiEndpoints';
import DatePicker from 'components/base/DatePicker';
import classNames from 'classnames';
import { formatDate } from 'services/utils';

const CreateShift = ({ show, handleClose, handleRefresh }) => {
  const [modalLoading, modalMessage, setModalLoading] = useModalManage();

  const { showAlert } = useAlert();

  const handleCreateShift = async values => {
    setModalLoading(true, 'Creating Shift');
    const request = await postData(values, apiEndpoints.shift.create);
    if (request.status) {
      setModalLoading(false);
      showAlert({
        variant: 'info',
        message: `Approval has been successfully raised to create the Shift ${values.shift_name}.`
      });
      handleRefresh();
      handleClose();
    } else {
      setModalLoading(false);
      showAlert({
        variant: 'danger',
        message: `Failed to create the Shift ${values.shift_name}.`
      });
    }
  };

  const formik = useFormik({
    initialValues: {
      shift_name: '',
      start_time: '',
      end_time: ''
    },
    validationSchema: Yup.object({
      shift_name: Yup.string()
        .required('Please Enter the Shift Name')
        .max(30, 'Shift Name cannot be longer than 30 characters'),
      start_time: Yup.string().required('Please Enter Start Time'),
      end_time: Yup.string().required('Please Enter End Time')
    }),

    onSubmit: values => {
      handleCreateShift(values);
    }
  });

  return (
    <CreateModal
      show={show}
      loading={modalLoading}
      loadingText={modalMessage}
      handleClose={handleClose}
      heading={'Create Shift'}
      handleSubmit={formik.handleSubmit}
    >
      <Row className="gy-2 gx-2">
        <Col xs={12} sm={12}>
          <InputBox>
            <LabelInput
              errorProps={{ tooltip: false }}
              label={'Shift Name'}
              controlId={'shift_name'}
              formik={formik}
              required
            />
          </InputBox>
        </Col>
        <Col xs={12} sm={6}>
          <InputBox>
            <Form.Group className="position-relative" controlId={'start_time'}>
              <Form.Label
                className={
                  'd-block mb-1 fs-9 ps-1 text-capitalize fw-medium fw-bold'
                }
              >
                Start Time*
              </Form.Label>

              <DatePicker
                onChange={date => {
                  formik.setFieldValue(
                    'start_time',
                    formatDate(date[0], 'HH:mm')
                  );
                }}
                options={{
                  dateFormat: 'H:i',
                  enableTime: true,
                  noCalendar: true,
                  time_24hr:true,
                  static: true
                }}
                className={classNames({
                  'is-invalid':
                    formik.touched['start_time'] && formik.errors['start_time']
                })}
                containerClassName={'custom-flat-picker'}
              >
                <Form.Control.Feedback tooltip type="invalid">
                  {formik.errors['start_time']}
                </Form.Control.Feedback>
              </DatePicker>
            </Form.Group>
          </InputBox>
        </Col>
        <Col xs={12} sm={6}>
          <InputBox>
            <Form.Group className="position-relative" controlId={'end_time'}>
              <Form.Label
                className={
                  'd-block mb-1 fs-9 ps-1 text-capitalize fw-medium fw-bold'
                }
              >
                End Time*
              </Form.Label>

              <DatePicker
                onChange={date =>
                  formik.setFieldValue('end_time', formatDate(date[0], 'HH:mm'))
                }
                options={{
                  dateFormat: 'H:i',
                  enableTime: true,
                  noCalendar: true,
                  time_24hr:true,
                  static: true
                }}
                className={classNames({
                  'is-invalid':
                    formik.touched['end_time'] && formik.errors['end_time']
                })}
                containerClassName={'custom-flat-picker'}
              >
                <Form.Control.Feedback tooltip type="invalid">
                  {formik.errors['end_time']}
                </Form.Control.Feedback>
              </DatePicker>
            </Form.Group>
          </InputBox>
        </Col>
      </Row>
    </CreateModal>
  );
};

export default CreateShift;
